var DateUtil = /** @class */ (function () {
    function DateUtil() {
    }
    DateUtil.parseUtcTime = function (dateString) {
        var dateParts = dateString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(\.\d{1,10})?([-+])(\d{2}):(\d{2})$/);
        if (dateParts === null) {
            return -1;
        }
        // Short access to date parts
        var d = dateParts.map(function (part) { return parseInt(part, 10); });
        var tzOffset = (d[9] * 60 + d[10]) * 60000 * (dateParts[8] === '-' ? -1 : 1);
        var time = Date.UTC(d[1], d[2] - 1, d[3], d[4], d[5], d[6]) - tzOffset;
        return time;
    };
    return DateUtil;
}());
export { DateUtil };
